import o from"./_baseAssignValue.js";import r from"./eq.js";var t=Object.prototype.hasOwnProperty;function a(a,e,s){var i=a[e];t.call(a,e)&&r(i,s)&&(void 0!==s||e in a)||o(a,e,s)}export{a as default};
//# sourceMappingURL=_assignValue.js.map
